/**
 * スクリーン座標をSVG座標系に変換する
 *
 * @param {number} screenX - スクリーン上のX座標（ページ全体での絶対位置）
 * @param {number} screenY - スクリーン上のY座標（ページ全体での絶対位置）
 * @param {DOMRect} containerRect - 画像コンテナのgetBoundingClientRect()の結果
 * @param {Object} imageNaturalSize - 画像の元サイズ {width, height}
 * @returns {Object} SVG座標系での座標 {x, y}
 */
export function screenToSvgCoordinates(screenX, screenY, containerRect, imageNaturalSize) {
  // コンテナ内での相対位置を計算（0.0 ~ 1.0）
  const relativeX = (screenX - containerRect.left) / containerRect.width;
  const relativeY = (screenY - containerRect.top) / containerRect.height;

  // 画像の元サイズに変換して整数に丸める
  return {
    x: Math.round(relativeX * imageNaturalSize.width),
    y: Math.round(relativeY * imageNaturalSize.height),
  };
}
